// You can write more code here

import { EventBus } from '@/game/GameComponents/PhaserGame/EventBus';
import GAME_EVENTS from '@/game/GameComponents/PhaserGame/Utils/gameEventsDef';
import { PhaserAudioManager } from '@/game/GameComponents/PhaserGame/Utils/PhaserAudioManager';
import {
  getAnchorPlugin,
  waitForSeconds,
} from '@/game/GameComponents/PhaserGame/Utils/PhaserUtils';
import { HOVER_CURSOR_PATH } from '@/game/GameComponents/Utils/GameSpriteAssetsMap';

/* START OF COMPILED CODE */

/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class DailiesCompleteNotification
  extends Phaser.GameObjects.Container
{
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // mainContainer
    const mainContainer = scene.add.container(0, 0);
    this.add(mainContainer);

    // notifBacking
    const notifBacking = scene.add.nineslice(
      -40,
      32,
      'fadeOut',
      undefined,
      56,
      8,
      3,
      1,
      1,
      1,
    );
    notifBacking.scaleX = 4;
    notifBacking.scaleY = 4;
    notifBacking.setOrigin(1, 0.5);
    notifBacking.tint = 4864576;
    mainContainer.add(notifBacking);

    // dailyText
    const dailyText = scene.add.bitmapText(
      -240,
      32,
      'Aronui',
      'Dailies Completed!',
    );
    dailyText.setOrigin(0, 0.5);
    dailyText.tintTopLeft = 15130076;
    dailyText.tintTopRight = 15130076;
    dailyText.tintBottomLeft = 15130076;
    dailyText.tintBottomRight = 15130076;
    dailyText.text = 'Dailies Completed!';
    dailyText.fontSize = -18;
    mainContainer.add(dailyText);

    // image_2
    const image_2 = scene.add.image(-40, 32, 'check1_on');
    image_2.scaleX = 4;
    image_2.scaleY = 4;
    image_2.tintTopLeft = 15130076;
    mainContainer.add(image_2);

    this.notifBacking = notifBacking;
    this.mainContainer = mainContainer;

    /* START-USER-CTR-CODE */

    this.initialize();
    /* END-USER-CTR-CODE */
  }

  private notifBacking: Phaser.GameObjects.NineSlice;
  private mainContainer: Phaser.GameObjects.Container;

  /* START-USER-CODE */

  duration: number = 5000;

  initialize() {
    this.doNotificationFeedback();
    this.notifBacking.setInteractive({ cursor: `${HOVER_CURSOR_PATH}` });
    this.notifBacking.on('pointerdown', () => {
      EventBus.emit(GAME_EVENTS.PLAYER_REQUESTED_OPEN_DAILIES_PANEL);
    });
    this.notifBacking.on('pointerover', () => {
      this.notifBacking.setTint(0x6f515d);
    });
    this.notifBacking.on('pointerout', () => {
      this.notifBacking.setTint(0x0f0a0c);
    });
  }

  async initializeResponsiveness() {
    const anchor = getAnchorPlugin(this.scene);
    await waitForSeconds(this.scene.time, 0.1);
    anchor.add(this, {
      right: '100%',
      top: '100%+384',
    });
  }

  doNotificationFeedback() {
    this.mainContainer.setX(300);
    setTimeout(() => {
      PhaserAudioManager.playSFX(this.scene, 'mentor-reveal');
      this.scene.tweens.add({
        targets: this.mainContainer,
        x: 0,
        duration: 750,
        ease: 'Back.easeInOut',
      });
      // Out tween
      this.scene.tweens.add({
        targets: this.mainContainer,
        x: 300,
        duration: 750,
        ease: 'Back.easeInOut',
        delay: this.duration,
        onComplete: () => {
          this.destroy();
        },
      });
    }, 3000);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
